<template>
  <div class="hello">
    <h1>{{ msg }}</h1>

    <h3>Vue4</h3>


    <el-button type="warning" @click="updateStoreData()">点击我更新store</el-button>
    <div v-for="(n,index) of userList">
      {{index}}.{{n.title}}
    </div>
    <div>
      {{userName}}
    </div>

  </div>
</template>

<script lang="ts">
  import { Options, Vue } from 'vue-class-component';
  import { defineComponent,ref} from "vue";
  import { useStore } from "vuex";

  import * as echarts from 'echarts'
  import "echarts/lib/chart/line";
  import "echarts/lib/component/title";
  import "echarts/lib/component/tooltip";
  import { reactive,onMounted,computed,toRefs} from 'vue'
  import { useRouter } from "vue-router";

export default defineComponent({
  props: {
    name: String,
    msg:String,
    userList:Array
  },
  // 初始化了 props 之后调用。setup() 会接收到初始的 props 作为参数：
  setup(props){
    const { msg } = toRefs(props);

    // console.log('props',newArr,msg);

    //ref 和 reactive 一样都是实现响应式数据的方法
    const userList = reactive([{title:'张三'},{title:'李四'}]);
    const userName = ref('我叫张三');
    const router = useRouter();
    // const chart = ref(null);
    const chart = ref();

    const numbers = ref([1, 2, 3])
    // 替代原数组，但引用不变
    numbers.value = numbers.value.filter(n => n > 1)
    console.log('numbers',numbers.value)

    // useStore().commit('setTitle','更新拉111');
    onMounted (() => {
      // console.dir(chart);
      // console.log(chart.value)
      const newArr = (props.userList as any).value;
      console.log('newArr',newArr)
      userList.push(newArr[0])
      setQuestion('')

    })
    const setQuestion = (question: string) => {
      const option = {
        series: {
          type: 'pie',
          data: [
            {name: 'A', value: 1212},
            {name: 'B', value: 2323},
            {name: 'C', value: 1919}
          ]
        }
      };
      console.log('chart',chart)
      // const Chart = echarts.init(chart);
      // Chart.setOption(option);
    };
     const gotoAbout = () =>{
      console.log('gotoAbout');
       router.push('/about');
    };
    useStore().commit('setTitle','更新拉111')
     const updateStoreData = ()=>{
       console.log('updateStoreData',useStore());
       // ;
    };
    return {
      userList,
      msg:props.msg,
      gotoAbout,
      userName,
      chart,
      updateStoreData
    }
  },


  // gotoAbout(){
  //   console.log('gotoAbout');
  //   this.$router.push('/about');
  // },
  gotohome(){
    this.$router.push('/home/newPage')
  },
  gotopage(page:any){
    this.$router.push('/home/'+ page)

  },

})
// export default class HelloWorld extends Vue {
//   msg: string = 'asdasdasd';
//   public chartDom: any = null;
//   props: {
//     title: String
//   }
//
// }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
  .block{
    width: 440px;
  }
  .hello{
    background-color: lightblue;
  }
</style>
